<template>
	<v-container class="pa-1">

    <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
      <strong> {{alerta.texto}} </strong>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <v-card-actions>
      <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> Cambiar Contraseña   </div>
      <v-spacer></v-spacer>
      <v-btn color="error" fab small elevation="1" @click="$emit('modal',false)" ><v-icon>clear</v-icon></v-btn>
    </v-card-actions>

    <!-- <v-container style="height: 300px;" v-if="Loading">
      <loading/>
    </v-container> -->

      <v-row class="mt-3">
        <v-col cols="12">
          <v-text-field
            v-model="password"
            prepend-icon="lock"
            :append-icon="show1 ? 'visibility' : 'visibility_off'"
            :type="show1 ? 'text' : 'password'"
            label="Contraseña"
            filled
            @click:append="show1 = !show1"
          ></v-text-field>
        </v-col>

      </v-row>

      <div class="mt-6"></div>

      <v-footer absolute >
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="modalPassword = true"> Cambiar Contraseña </v-btn>
      </v-footer>
      
    
    <v-dialog v-model="modalPassword" persistent width="500">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">¿ESTÁS SEGURO DE QUERER CAMBIAR LA CONTRASEÑA ? </v-card-title>
          <v-divider class="my-0 py-3" ></v-divider>
          <v-card-subtitle align="center" class="red--text font-weight-bold "> UNA VEZ MODIFICADA NO PODRÁ RECUPERAR </v-card-subtitle>
          <v-divider class="my-0 py-2 " ></v-divider>
          <v-card-actions>
            <v-btn color="error" dark @click="modalPassword=false" >  NO, Cancelar </v-btn>
            <v-spacer/>
            <v-btn color="primary" text @click="modificarPassword()" >  SÍ, Cambiar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

		<overlay v-if="overlay"/>
  </v-container>
</template>

<script>
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  var md5     = require('md5');

  // import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'

  export default {
    mixins:[metodos],
	  components: {
			// loading,
      overlay
		},
		props:[
			'parametros',
	  ],

    data(){
      return{
        // Loading: false,
        password: '',
        show1: false,
        alerta: { activo: false, texto:'', color:'error' },
        overlay: false,
        modalPassword: false, 

      }
    },

    created(){
				this.initialize();
		},

    watch:{
			parametros(){
				this.initialize();
			},
    },
			
		computed:{
			// IMPORTANDO USO DE VUEX - CLIENTES (GETTERS)
      ...mapGetters('Login',['getusuarioFetish']),
		},

    watch: {
    },

    methods:{
      
      async initialize(){
      },

      modificarPassword() {
        this.overlay = true;
        this.modalPassword = false;
        
        const payload = {
          idusuario: this.parametros.idusuariosweb,
          password: md5(this.password)
        }

        this.$http.post('cambio.contrasenia', payload).then( response =>{
          var that = this;
          this.alerta = { activo: true, color:'success', texto: "Se cambio la contraseña correctamente." };
          setTimeout(() => { 
            that.$emit('modal');
            that.$emit('init');
          }, 1000);
          // this.finalizarProceso()
        }).catch( error =>{
          console.log('error', error);
          this.alerta = { activo: true, color:'error', texto: error.message };
        }).finally(()=>{ 
          this.overlay = false
        })

      }

    } 

  }
</script>